import * as SagaType from '../../constants/constant_saga_types';

const INITIAL_STATE = {
  error: '',
  offset: 0,
  total: 0,
  limit: 10,
  isLoading: false,
  pristine: true,
  data: [],
  form: null,
};

export default function recordPreviewReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SagaType.FETCHING_RECORD_PREVIEW: {
      return {
        ...state,
        ...action.payload,
        error: '',
      };
    }

    case SagaType.DONE_FETCH_RECORD_PREVIEW: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        error: '',
      };
    }

    case SagaType.FETCH_RECORD_PREVIEW_ERROR: {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };
    }

    default:
      return state;
  }
}
